import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Paginacao } from '@app/models/util/paginacao';
import { CDSMask } from '@app/utils/cds-mask';
import { Cheque } from '@app/models/cheque';
import { ChequeService } from '@app/services/cheque.service';
import { ListaChequePesquisaFiltros } from '@app/models/lista-cheque-pesquisa-filtros';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ToastrService } from 'ngx-toastr';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { UsuarioTipoService } from '@app/services/usuario-tipo.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-lista-cheque',
  templateUrl: 'lista-cheque.component.html'
})
export class ListaChequeComponent implements OnInit {

  @ViewChild('modal', { static: true }) public modal: TemplateRef<any>;

  lstChequeCredito: Cheque[];
  lstChequeDebito: Cheque[];
  lstErros: string[];
  pesquisa: ListaChequePesquisaFiltros = new ListaChequePesquisaFiltros();
  paginacao: Paginacao = new Paginacao();
  cdsMask: CDSMask = new CDSMask();
  TipoDrId: number;
  lstBanco: IdDescricao[];
  lstConta: IdDescricao[];
  lstTipoDr: IdDescricao[];
  compensarDataCompensado: string;
  compensarContaId: number;
  compensarChequeId: number;
  compensarTipo = '';
  modalReference: BsModalRef = null;
  pesquisando: boolean;
  pesquisandoReceber: boolean;
  pesquisandoPagar: boolean;

  // @ViewChild('modalCompensarCheque', { static: true }) modalCompensarCheque: TemplateRef<any>;

  acessoDescompensar: boolean;

  constructor(private chequeService: ChequeService,
    @Inject(ToastrService) public toastr: ToastrService,
    private _modalService: BsModalService,
    private consultasServices: ConsultasService,
    private usuarioTipoService : UsuarioTipoService
  ) {

  }

  ngOnInit() {
    this.consultasServices.consultar('CONTA').toPromise().then(data => this.lstConta = data);
    this.consultasServices.consultar('BANCO').toPromise().then(data => this.lstBanco = data);
    this.consultasServices.consultar('DR').toPromise().then(data => this.lstTipoDr = data);


    // this.bancoService.obterTodos().subscribe(data => {  });
    // this.tipoDRService.obterTodosSemGrupo('').subscribe(data => this.lstTipoDr = data);
    this.obterTodosPagar(1);
    this.obterTodosReceber(1);
    // this.contaService.obterTodos().subscribe(data => { this.lstConta = data; });
    this.compensarDataCompensado = UtilitarioService.retornaDataAtualMaisDias(0);

    this.usuarioTipoService.verificaPermissaoUsuario().subscribe((permissao: any) => {
      this.acessoDescompensar = permissao.find(x => x.Descricao == 'DescompensarCheque').Selecionado;
    });
  }


  obterTodosPagar(pagina: number) {
    this.pesquisando = true;
    this.pesquisandoPagar = true;

    this.pesquisa.Pagina = pagina;
    this.pesquisa.TipoCreditoDebito = 'PAGAR';
    this.chequeService.obterPesquisa(this.pesquisa)
      .toPromise().then(data => {

        if(data.Total < 1)
          this.toastr.warning(`Nenhum cheque a pagar encontrado entre ${ this.pesquisa.DataInicial } e ${ this.pesquisa.DataFinal }`);

        this.lstChequeDebito = data.Dados;
        this.paginacao.totalDeItens = data.Total;
        this.pesquisandoPagar = false;
        if (!this.pesquisandoPagar) {
          this.pesquisando = false;
        }
      },erro => {
        this.pesquisandoPagar = false;
        if (!this.pesquisandoPagar) {
          this.pesquisando = false;
        }
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }
  obterTodosReceber(pagina: number) {
    this.pesquisando = true;
    this.pesquisandoReceber = true;

    this.pesquisa.Pagina = pagina;
    this.pesquisa.TipoCreditoDebito = 'RECEBER';
    this.chequeService.obterPesquisa(this.pesquisa)
      .toPromise().then(data => {

        if(data.Total < 1)
          this.toastr.warning(`Nenhum cheque a receber encontrado entre ${ this.pesquisa.DataInicial } e ${ this.pesquisa.DataFinal }`);

        this.lstChequeCredito = data.Dados;
        this.paginacao.totalDeItens = data.Total;
        this.pesquisandoReceber = false;
        if (!this.pesquisandoReceber && !this.pesquisandoPagar) {
          this.pesquisando = false;
        }
      });
  }

  obterTodos() {
    this.pesquisando = true;
    this.obterTodosPagar(1);
    this.obterTodosReceber(1);
  }

  validarFormCompensarCheque(): boolean {
    if (!(this.compensarChequeId > 0)) {
      this.toastr.warning('Realize a pesquisa novamente');
      return false;
    } else if (!(this.compensarContaId > 0)) {
      this.toastr.warning('Escolha a conta em que o cheque será compensado');
      return false;
    }

    const dataSplited = this.compensarDataCompensado.split('-');
    const diaSelecionado = Number(dataSplited[2]);
    const mesSelecionado = Number(dataSplited[1]) - 1;
    const anoSelecionado = Number(dataSplited[0]);
    const dataSelecionada = new Date(anoSelecionado, mesSelecionado, diaSelecionado);

    const hoje = new Date();
     if(dataSelecionada > hoje) {
       this.toastr.warning('Só é possível definir a data se o cheque foi compensado hoje ou anteriormente');
       return false;
     }

    return true;
  }

  compensarCheque() {
    if(!this.validarFormCompensarCheque()) {
      return;
    }

    this.chequeService.compensarCheque(this.compensarChequeId, this.compensarContaId, this.compensarTipo, this.compensarDataCompensado)
    .toPromise().then(data => {
          this.compensarChequeId = 0;
          this.compensarTipo = '';
          this.modalReference.hide();
          this.obterTodosPagar(1);
          this.obterTodosReceber(1);
        }, (data) => {
          this.toastr.error(data.errors[0]);
    });
    
  }

  abrirModal(content: TemplateRef<any>, chequeId, tipo) {
    this.compensarChequeId = chequeId;
    this.compensarTipo = tipo;
    this.modalReference = this._modalService
      .show(content);
  }

  descompensarCheque(id: number){
    this.chequeService.descompensarCheque(id).toPromise().then( data => {
      this.obterTodosPagar(1);
      this.obterTodosReceber(1);
    }, (data) => {
      this.toastr.error(data.errors[0]);
    });
  }

  fecharModal(modalReferencia: BsModalRef) {
    modalReferencia.hide();
  }
}


